import { Model } from "vue-mc";

export class SeOOB extends Model {
  defaults() {
    return {
      clave: null
      , nombre: ""
      , nombrePersonaContacto: ""
      , cuit: ""
      , direccion: ""
      , altura: ""
      , provincia: null
      , localidad: null
      , referencia: ""
      , cp: ""
      , email: ""
      , telefono: ""
      , latitud: ""
      , longitud: ""
      , geoRelevancia: null
      , photos: null
      , estatus: true
    };
  }

  mutations() {
    return {
      clave: (clave) => clave
      , nombre: (nombre) => nombre
      , nombrePersonaContacto: (nombrePersonaContacto) => nombrePersonaContacto
      , cuit: (cuit) => cuit
      , direccion: (direccion) => direccion
      , altura: (altura) => altura
      , provincia: (provincia) => provincia
      , localidad: (localidad) => localidad
      , referencia: (referencia) => referencia
      , cp: (cp) => cp
      , telefono: (telefono) => telefono
      , latitud: (latitud) => latitud
      , longitud: (longitud) => longitud
      , geoRelevancia: (geoRelevancia) => geoRelevancia
      , photos: (photos) => photos
      , status: (status) => status
    };
  }

  validation() {
    return {};
  }

  options() {
    return {};
  }
}



// WEBPACK FOOTER //
// ./src/models/operativos/seOOB.js